import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class EditableWrapper extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired,
  };

  state = {
    isEditable: false,
  };

  changeEditable = isEditable => this.setState({ isEditable });

  render() {
    const { isEditable } = this.state;

    const rootClass = classNames(
      'data-rows-group', 'nested-1',
      { 'is-editable': isEditable }
    );

    return (
      <div className={rootClass}>
        {this.props.children(this.changeEditable)}
      </div>
    );
  }
}

export default EditableWrapper;
